function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 
 * @file Helper for the box Task Collaborators API
 * @author Box
 */
import omit from 'lodash/omit';
import TasksBase from './TasksBase';
import { ERROR_CODE_FETCH_TASK_COLLABORATOR, ERROR_CODE_CREATE_TASK_COLLABORATOR, ERROR_CODE_UPDATE_TASK_COLLABORATOR, ERROR_CODE_DELETE_TASK_COLLABORATOR, API_PAGE_LIMIT } from '../../constants';

class TaskCollaborators extends TasksBase {
  getUrlForTaskCollaborators(taskId) {
    return "".concat(this.getBaseApiUrl(), "/undoc/tasks/").concat(taskId, "/task_collaborators?role=ASSIGNEE&limit=").concat(API_PAGE_LIMIT);
  }

  getUrlForTaskCollaboratorCreate() {
    return "".concat(this.getBaseApiUrl(), "/undoc/task_collaborators");
  }

  getUrlForTaskCollaborator(id) {
    return "".concat(this.getBaseApiUrl(), "/undoc/task_collaborators/").concat(id);
  }

  getUrlForTaskGroupCreate() {
    return "".concat(this.getBaseApiUrl(), "/undoc/task_collaborators/expand_group");
  }

  createTaskCollaborator(_ref) {
    let {
      errorCallback,
      file,
      successCallback,
      task,
      user
    } = _ref;
    this.errorCode = ERROR_CODE_CREATE_TASK_COLLABORATOR;
    const requestData = {
      data: {
        task: {
          type: 'task',
          id: task.id
        },
        target: {
          type: 'user',
          id: user.id
        }
      }
    };
    this.post({
      id: file.id,
      url: this.getUrlForTaskCollaboratorCreate(),
      data: _objectSpread({}, requestData),
      successCallback,
      errorCallback
    });
  }

  createTaskCollaboratorsforGroup(_ref2) {
    let {
      errorCallback,
      file,
      successCallback,
      task,
      group
    } = _ref2;
    this.errorCode = ERROR_CODE_CREATE_TASK_COLLABORATOR;
    const requestData = {
      data: {
        task: {
          type: 'task',
          id: task.id
        },
        target: {
          type: 'group',
          id: group.id
        }
      }
    };
    this.post({
      id: file.id,
      url: this.getUrlForTaskGroupCreate(),
      data: _objectSpread({}, requestData),
      successCallback,
      errorCallback
    });
  }

  getTaskCollaborators(_ref3) {
    let {
      errorCallback,
      file,
      successCallback,
      task
    } = _ref3;
    this.errorCode = ERROR_CODE_FETCH_TASK_COLLABORATOR;
    const url = this.getUrlForTaskCollaborators(task.id);
    this.get({
      id: file.id,
      successCallback,
      errorCallback,
      url
    });
  }

  updateTaskCollaborator(_ref4) {
    let {
      errorCallback,
      file,
      successCallback,
      taskCollaborator
    } = _ref4;
    this.errorCode = ERROR_CODE_UPDATE_TASK_COLLABORATOR;
    const requestData = {
      data: omit(taskCollaborator, 'id')
    };
    this.put({
      id: file.id,
      url: this.getUrlForTaskCollaborator(taskCollaborator.id),
      data: _objectSpread({}, requestData),
      successCallback,
      errorCallback
    });
  }

  deleteTaskCollaborator(_ref5) {
    let {
      errorCallback,
      file,
      successCallback,
      taskCollaborator
    } = _ref5;
    this.errorCode = ERROR_CODE_DELETE_TASK_COLLABORATOR;
    this.delete({
      id: file.id,
      url: this.getUrlForTaskCollaborator(taskCollaborator.id),
      successCallback,
      errorCallback
    });
  }

}

export default TaskCollaborators;
//# sourceMappingURL=TaskCollaborators.js.map